export default {
  GET_THE_APP: 'Obtenga la aplicaci\u00f3n',
  MAKE_FLOCK_BETTER_APPS: 'Mejorar Flock con aplicaciones',
  URL_APP_DECORATOR_NO_PROMPT_TEXT:
    'Ok, no haremos sugerencias de aplicaciones para {appOrDomain}.\nVisite la {flockStore} para descubrir aplicaciones.',
  FLOCK_APP_STORE: 'Tienda de la aplicaci\u00f3n Flock',
};
